import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";
import { ProductAction } from "../../types/actions.product";
import { Product } from "../../types/product";

// gets all products but does NOT get table data
const subscribeToAllProducts = (): AppThunk<() => void> => (dispatch) => {
    const unsubscribe = firebase
        .firestore()
        .collection("products")
        .onSnapshot(async (querySnapshot) => {
            const products: Array<Product> = [];
            await Promise.all(
                querySnapshot.docs.map(
                    async (doc: firebase.firestore.DocumentData) => {
                        const product = doc.data() as Product;
                        products.push(product);
                    }
                )
            );
            dispatch({
                type: ProductAction.SET_PRODUCTS,
                products,
            });
        });

    return unsubscribe;
};

export default subscribeToAllProducts;
